import api from '../utils/api';

const BASE_PATH = '/customer/wishlist';

const getWishlist = async () => {
  return await api.get(BASE_PATH);
};

const addToWishlist = async (data) => {
  // data should contain { itemId, itemType }
  return await api.post(BASE_PATH, data);
};

const removeFromWishlist = async (wishlistItemId) => {
  return await api.delete(`${BASE_PATH}/item/${wishlistItemId}`);
};

const clearWishlist = async () => {
  return await api.delete(BASE_PATH);
};

export default {
  getWishlist,
  addToWishlist,
  removeFromWishlist,
  clearWishlist
};
